
import React from 'react'
import icon from './svgs/gridSearch.svg'
import { BaseIcon } from './_base'

export const GridSearchIcon = ({ size, fontSize ,sx}) => {
    return (
        <BaseIcon icon ={icon} {...{fontSize,size,...sx}} />
    )
}
